import axios from 'axios'

export function resetListing() {
  return {
    type: 'LISTING_RESET',
  }
}

export function fetchListing(id) {
  return (dispatch) =>
    dispatch({
      type: 'LISTING_FETCH',
      payload: axios(`/listings/${id}`),
    })
}

export default fetchListing
